import { Edit } from "@mui/icons-material";
import Paper from "@mui/material/Paper";
import { Table } from "../../components/Table";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import { useCallback, useEffect, useState } from "react";
import { DatePicker } from "../../components/DatePicker";
import { Autocomplete } from "../../components/Autocomplete";
import { useStyles } from "./styles";
import Stack from "@mui/material/Stack";
import { Search } from "@mui/icons-material";
import { listOffers } from "../../services/offers";
import { useQuery } from "react-query";
import { subMonths } from "date-fns";
import { listStores } from "../../services/insights";
import { Store } from "../../types/insights";
import { NewOffers } from "./New";
import { EditOffers } from "./Edit";
import { Offer } from "../../types/offers";
import { useSearchParams } from "react-router-dom";

export const Offers = () => {
  const styles = useStyles();
  const [searchParams] = useSearchParams();
  const [startDate, setStartDate] = useState<Date>(subMonths(new Date(), 1));
  const [endDate, setEndDate] = useState<Date>(new Date());
  const [store, setStore] = useState<Store | null>(null);
  const [selectedOffer, setSelectedOffer] = useState<Offer>();
  const [offerName, setOfferName] = useState<string>();
  const [dialogNewOffer, setDialogNewOffer] = useState<boolean>(
    Boolean(searchParams.get("create"))
  );
  const [dialogEditOffer, setDialogEditOffer] = useState<boolean>(false);

  const handleDialogNewOffer = useCallback(() => {
    setDialogNewOffer((prev) => !prev);
  }, []);

  const handleDialogEditOffer = useCallback((data?: Offer) => {
    setSelectedOffer(data);
    setDialogEditOffer((prev) => !prev);
  }, []);

  const stores = useQuery("stores", listStores);

  const offers = useQuery("offers", async () => {
    const response = await listOffers(
      startDate,
      endDate,
      store?.id_loja,
      offerName
    );

    return response;
  });

  const handleRefetch = useCallback(() => {
    offers.refetch();
  }, [offers]);

  useEffect(() => {
    if (searchParams.get("create")) {
      setDialogNewOffer(Boolean(searchParams.get("create")));
    }
  }, [searchParams]);

  return (
    <>
      <Stack spacing={4}>
        <Stack className={styles.root}>
          <Typography variant="h4">Descontos personalizados</Typography>
          <Typography variant="body2">
            Aqui fica todos os seus descontos personalizados.
          </Typography>
        </Stack>
        <Stack direction="row" justifyContent="space-between">
          <Stack direction="row" spacing={1}>
            <DatePicker
              fullWidth
              size="small"
              label="Data de início"
              value={startDate}
              onChange={(date) => setStartDate(date as Date)}
            />
            <DatePicker
              fullWidth
              size="small"
              label="Data de término"
              value={endDate}
              onChange={(date) => setEndDate(date as Date)}
            />
            <Autocomplete
              fullWidth
              size="small"
              label="Loja"
              options={stores.data}
              getOptionLabel={(option) => option.nome_loja}
              onChange={(_, option) => setStore(option)}
            />
            <TextField
              label="Nome"
              onChange={({ target: { value } }) => setOfferName(value)}
              fullWidth
              size="small"
            />
            <Button
              onClick={handleRefetch}
              fullWidth
              startIcon={<Search />}
              color="primary"
            >
              Buscar
            </Button>
          </Stack>

          <Button
            onClick={handleDialogNewOffer}
            variant="contained"
            color="primary"
          >
            Criar desconto personalizado
          </Button>
        </Stack>
        <Paper
          variant="outlined"
          elevation={0}
          className={styles.paperCreatedDay}
        >
          <Table
            isLoading={offers.isLoading}
            toolbar={false}
            data={offers.data}
            columns={[
              { title: "Nome", field: "nome_oferta" },
              {
                title: "Tipo da oferta",
                field: "tipo_oferta",
              },
              {
                title: "Ações",
                render: (row) => (
                  <Stack spacing={1} direction="row">
                    <Tooltip title="Editar" placement="top">
                      <IconButton
                        onClick={() => {
                          handleDialogEditOffer(row);
                        }}
                      >
                        <Edit />
                      </IconButton>
                    </Tooltip>
                  </Stack>
                ),
              },
            ]}
            style={{ backgroundColor: "transparent" }}
            headerStyle={{ backgroundColor: "transparent" }}
            options={{
              actionsColumnIndex: -1,
              pageSize: 7,
              selectionProps: () => ({
                color: "primary",
              }),
            }}
          />
        </Paper>
      </Stack>
      <NewOffers onClose={handleDialogNewOffer} open={dialogNewOffer} />
      <EditOffers
        offer={selectedOffer}
        onClose={handleDialogEditOffer}
        open={dialogEditOffer}
      />
    </>
  );
};
